import React from "react";
// import AuthorImg1 from "../../../assets/images/authorImg1.png";
import RatingStar from "../../../assets/images/rating.png";
import { useApi } from "../../../hooks/useApi";
import { API_ENDPOINTS } from "../../../api/endpoints";
import Loader from "../../../components/Loader/Loader";
import ErrorMsg from "../../../components/ErrorMsg/ErrorMsg";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

import styles from "./MentorsProgram.module.css";

export default function MentorsProgram() {
  const navigate = useNavigate();
  const { setAuthModal, userdata } = useAuth();

  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_FEATURE_MENTORS
  );
  const apiData = response?.featuredMentors;

  const handleBecomeMember = () => {
    if (userdata) {
      // User is logged in, redirect to appropriate dashboard
      if (userdata.role === 'institution') {
        navigate('/dashboard/institution');
      } else {
        navigate(`/dashboard/${userdata.role}`);
      }
    } else {
      // User is not logged in, open signup popup
      setAuthModal({ open: true, tab: "signup" });
    }
  };
  return (
    <section className={styles.mentors}>
      <div className={styles.container}>
        <div className={styles.topContainer}>
          <div className={styles.heading}>
            <h3>
              Mentorship <span>Program</span>
            </h3>
            <h5>
              Connect with experienced professionals and accelerate your career
            </h5>
          </div>
          <div className={styles.viewAll}>
            <button onClick={() => navigate("/mentors")}>View All Profiles</button>
          </div>
        </div>
        <div className={styles.cards}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            apiData.slice(0, 3).map((t) => (
              <article className={styles.card} key={t.id}>
                <div className={styles.userDetails}>
                  <figure>
                    <img src={t.mentor.photograph} alt={t.title} />
                  </figure>
                  <div className={styles.content}>
                    <h6>{t.mentor.full_name}</h6>
                    <p title={`${t.mentor.current_designation} |  ${t.mentor.departmentFacultyName} | ${t.mentor.institution_name},  ${t.mentor.city}`}>
                      {t.mentor.current_designation} |  {t.mentor.departmentFacultyName} | {t.mentor.institution_name},  {t.mentor.city}
                    </p>
                  </div>
                </div>

                <div className={styles.details}>
                  {t.mentor.profileSummary?.length > 88
                    ? `${t.mentor.profileSummary.substring(0, 88)}...`
                    : t.mentor.profileSummary}
                </div>
                <div className={styles.tagOuter}>
                  <button
                    onClick={() => navigate(`/mentors/${t.mentor.user_id}`)}
                  >
                    View Profile
                  </button>
                  {/* <button
                                 className={styles.active}
                                 onClick={() => navigate(`/mentors/${t.mentor.user_id}`)}
                               >
                                 Request Session
                               </button> */}
                </div>
              </article>
            ))
          )}
        </div>
        <button onClick={handleBecomeMember} className={styles.becomeMentor}>Become a Mentor</button>
      </div>
    </section>
  );
}
